import React from "react";

import { AuditLogIcon } from "assets";

export const APPROVALS = {
  ABSOLUTE_PATH: "/approvals",
  TITLE: "Approvals",
  ICON: <AuditLogIcon />,
  IS_TBD: false,
  renderMenu: false,
};

export const APPROVALS_LOCAL_STORAGE_KEYS = {
  FILTERS: "approvals-page-filters",
  REQUIRED_FIELDS: ["action", "user", "userSign", "createDate", "siteName", "monthYear"],
};

export const APPROVALS_TABLE = {
  COLUMN_TO_SORT_COLUMN_MAP: {
    action: "ACTION",
    user: "USER",
    userSign: "USER_SIGN",
    createDate: "CREATE_DATE",
    siteName: "SITE_NAME",
    monthYear: "MONTH_YEAR",
  },
  INITIAL_SORTING_STATE: [{ id: "monthYear", desc: false }],
  ROWS_PER_PAGE_OPTIONS: [50, 100, 200],
  COLUMN_TO_FILTER_COLUMN_MAP: {
    action: "Action",
    user: "Name",
    userSign: "Signature",
    createDate: "Time Stamp",
    siteName: "Site Name",
    monthYear: "Month/Year",
  },
};

export const APPROVALS_MESSAGES = {
  SIGN_OFF_SUCCESS: "Data Signed Off Successfully!",
  SIGN_OFF_ERROR: "Some error has happen while performing Sign Off!",
  UNDO_SIGN_OFF_SUCCESS: "Undo Sign-off Successfully!",
  UNDO_SIGN_OFF_ERROR: "Some error has happen while performing data Undo Sign-off!",
  LOCK_SUCCESS: "Data Locked Successfully!",
  LOCK_ERROR: "Some error has happen while performing data Locking!",
  UNDO_LOCK_SUCCESS: "Data Unlocked Successfully!",
  UNDO_LOCK_ERROR: "Some error has happen while performing data Unlocking!",
};
